import {useEffect, useRef} from 'react';
import {usePostHog} from '@posthog/react';
import {useAuth} from '@common/auth/use-auth';

/**
 * Identifies authenticated users (numeric ID + email only) and resets on logout.
 */
export function PostHogIdentityBridge() {
  const posthog = usePostHog();
  const {user, isLoggedIn} = useAuth();
  const identifiedIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    if (isLoggedIn && user?.id != null) {
      const distinctId = String(user.id);
      if (identifiedIdRef.current !== distinctId) {
        posthog.identify(distinctId, {
          email: user.email || undefined,
        });
        identifiedIdRef.current = distinctId;
      }
      return;
    }

    if (identifiedIdRef.current !== null) {
      posthog.reset();
      identifiedIdRef.current = null;
    }
  }, [posthog, isLoggedIn, user?.id, user?.email]);

  return null;
}
